


































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { InputFieldCpt, SubmitButtonCpt, BaseFormComponent, ValidationMessageCpt } from '@/core/components/form';
import { WorkshopService } from '@/core/services';
import { CompanyModel } from '@/core/models';

@Component({
  components: {
    InputFieldCpt,
    SubmitButtonCpt,
    ValidationMessageCpt,
  },
})
export default class EditAttendeeFormCpt extends BaseFormComponent {
  @Prop() companyModel: CompanyModel;
  @Prop({ default: false }) loading: boolean;
  @Prop() attendeePrefixField: string;
  @Prop() participantId: number;
  @Prop({ default: 'Participant' }) title: string;

  isEditing = false;
  isSubmitButtonDisabled = false;
  isSubmitting = false;

  editName() {
    this.isEditing = true;
  }

  endEditName() {
    this.isEditing = false;
  }

  get isError() {
    return this.companyModel.modelState && this.companyModel.modelState[this.nameField];
  }

  get nameField() {
    return this.attendeePrefixField + 'Name';
  }

  get emailField() {
    return this.attendeePrefixField + 'Email';
  }

  get idField() {
    return this.attendeePrefixField + 'Id';
  }

  async onSubmitForm() {
    if (!this.companyModel.workshopId) {
      return;
    }
    try {
      this.isSubmitting = true;
      await WorkshopService.postWorkshopClient(this.companyModel.workshopId, this.companyModel);
      this.$emit('onSave', true, this.companyModel);
      this.notify('Success', 'Attendee succesfully updated', 'success');
    } catch (err) {
      this.$emit('onSave', false, this.companyModel);
      this.notify('Error', 'Something went wrong while updating the Attendee', 'error');
    } finally {
      this.isSubmitting = false;
    }
  }
}
